import React from "react";

export default class TextConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationText: "",
      text: "",
      confirmCheckbox: false,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      confirmationText: `${$("#account_name").val()} ${$(
        "#property_name"
      ).val()}`,
    
    });
  }

  render() {
    return (
      <div className="TextConfirmation">
        <div
          className="alert alert-danger"
          style={{ marginTop: "15px", marginBottom: 0 }}
        >
          <div className="form-group" style={{ margin: 0}}>
            <label style={{ whiteSpace: "normal"}}>
              {I18n.t("please_confirm_this_action_by_typing", {
                text: this.state.confirmationText,
              })}
            </label>
            <input
              type="text"
              placeholder={this.state.confirmationText}
              value={this.state.text}
              onChange={this.onChange}
              className="form-control"
            />
            
            {
              this.props.showDoubleConfirmation == true
                ? 
                  <div className="flexed confirm-checkbox-wrapper">
                    <br/>
                    <label className="confirm-checkbox-label">
                      {I18n.t('confirm')}:
                    </label>
                    <input
                      className="confirm-checkbox"
                      type="checkbox"
                      value={this.state.confirmCheckbox}
                      onChange={this.onChangeDoubleConfirmation}
                    />
                  </div>
                : 
                  null
            }
          </div>
        </div>
      </div>
    );
  };

  onChange = (e) => {
    this.setState({ text: e.target.value }, () => {
      if (typeof this.props.onTextConfirmation === "function") { 
        this.props.onTextConfirmation(
          this.state.text === this.state.confirmationText
        );   
      };
    }); 
  };

  onChangeDoubleConfirmation = (e) => {
    this.setState({ secondText: e.target.checked }, () => {
      if (typeof this.props.onDoubleTextConfirmation === "function") { 
        this.props.onDoubleTextConfirmation(
          e.target.checked
        );   
      };
    }); 
  };
};
